export default {
  product: "Product",
  quantity: "Quantity",
  attributes: "Attributes",
  points: "Points",
  point: "Point",
  action: "Action",
  clear: "Clear",
  back: "Back",
  save: "Save",
  close: "Close",
  of: "Of",
  to: "to",
  copyrights: "© {date} Bridgestone Solutions. All rights reserved.",
  pageNotFound: "Page not found",
  accessDenied: "Access Denied",
  search: "Search",
  dashboard: {
    profile: {
      welcome: "Welcome",
      completeProfile: "Complete your personal profile and additionally",
      completeProfileBold: "secure 200 points.",
      link: "View profile",
      fullCompleteProfile: "Your personal profile is complete! ",
    },
    pobox: {
      newMessages: "New messages in your inbox",
      link: "View messages",
    },
    bankstatement: {
      yourScore: "Your current score:",
      lastUpdate: "Last updated:",
      link: "View points overview",
      kickbackLink: "View kickback fees overview",
      yourKickback: "Your current kickback fees:",
    },
    showAllProducts: "Go to the rewards shop",
  },
  pageName: {
    preislisten: "Brochures and Price lists",
    preislistenList: "Price lists",
    dashboard: "Dashboard",
    trainings: "Trainings",
    onlineTrainings: "Online trainings",
    bridgestoneSchulungen: "Bridgestone trainings",
    shop: "Rewards shop",
    shopProducts: "Rewards shop",
    shopCategory: "Rewards shop",
    product: "Product",
    productDetails: "Product details",
    productInfo: "Product information",
    pkw: "Passenger cars",
    motorrad: "Motorcycles",
    lkwUndBusse: "Trucks and buses",
    produktbroschuren: "Product brochures",
    pricat: "Pricat",
    landwirtschaft: "Agriculture",
    baumaschinenOtr: "Construction machines - Otr",
    bDrive: "Tire images & logos",
    beanstandungsFormular: "Complaint form",
    bridgestoneProduktbroschuren: "Bridgestone products",
    firestoneProduktbroschuren: "Firestone products",
    technologien: "Technologies, markings, and more",
    training: "Training",
    trainingForm: "Training form",
    account: "My account",
    pointsOverview: "My points account",
    stammdaten: "My contact information",
    mailbox: "Inbox",
    singleMailbox: "Message",
    bridgestoneSingleSchulungen: "Bridgestone trainings training",
    externeTraining: "External trainings",
    shoppingCart: "Shopping cart",
    orderSummary: "Order overview",
    orderDelivery: "Shipping address",
    orderComplete: "Order complete",
    text_page: "Static page",
    contact_service: "Contact & service",
    sales_support: "Sales support",
    salesPromotions: "Sales promotions",
    productInfoAndPriceList: "Product information & price lists",
    service_number: "Service numbers",
    about: "About BRIDGESTONE PLUS",
    contact_form: "Complaint form",
    userOrders: "My orders",
    userOrder: "Your order",
    hunterShop: "Hunter",
    wholesaler: "Dashboard for strategic partners",
    news_feeds: "News",
    investment: "Investment support",
    staff: "Dashboard",
    fuelCalculator: "Fuel savings calculator",
    myAccount: "Your account",
    myPoints: "My tire orders",
    commitmentLetter: "Commitment letter",
    rewardsOverview: "Explanation of the kickback fee and points",
    strategic_partners: "Contact to the sales partner",
    first_stop: "Bridgestone tire warranty",
    staffVouchers: "Vouchercodes",
    wholesalerVouchers: "Vouchercodes",
    brochure_prices: "Product brochures & price lists",
    touch_incentive: "Contact Touch Incentive",
    favoriteProducts: "Favorite products",
  },
  account: {
    title: "My Account",
    desc: "Welcome to your personal area. Here you can add or <br/> modify your contact information, view your inbox, and view your points account statement.",
    descStaff:
      "Welcome to your personal area. Here you can add or <br/> modify your contact information, view your inbox, and view your points account statement.",
    categories: {
      basedata: {
        title: "Contact information",
        desc: "Complete your contact and company information here for successful participation.",
      },
      pobox: {
        title: "Inbox",
        desc: "Find important messages, order confirmations, and news in your personal inbox.",
      },
      bankstatement: {
        title: "Statement",
        desc: "Here you can view your current points balance and account movements.",
      },
    },
  },
  profile: {
    title: "My Contact Information",
    description:
      "Welcome to your personal area. Here you can add or modify your contact information, view your inbox, and view your points account statement.",
    personalData: "Personal Information",
    password: "Password",
    password1: "Password (optional)*",
    password2: "Password (repeat)*",
    formOfAddress: "Salutation",
    choose: "Please select",
    mr: "Mr.",
    mrs: "Ms.",
    diverse: "Other",
    firstname: "First name",
    surname: "Last name",
    position: "Position in the company",
    operatingData: "Business Information",
    company: "Company name",
    legalForm: "Legal form",
    name: "Name",
    streetHouseNr: "Street and house number",
    street: "Street",
    postcode: "Postal code",
    location: "City",
    country: "Country",
    de: "Germany",
    at: "Austria",
    ch: "Switzerland",
    nl: "Netherlands",
    it: "Italy",
    language: "Language",
    french: "French",
    italian: "Italian",
    german: "German",
    nederland: "Dutch",
    phone: "Phone number",
    website: "Website",
    operatingIndicators: "Business KPIs",
    tireSale: "Approximate tire sales per year in units",
    tireSaleLabel: "Sell tires in quantities",
    inches: "Of which ≥ 18 inches (in %)",
    inchesLabel: "Of which 18 inches and larger in %",
    segmentSale: "Tire sales by segment (percentage of budget / mid / premium)",
    premBudget: "Premium",
    midBudget: "Mid",
    budBudget: "Budget",
    distribution: "DISTRIBUTION SUMMER / WINTER / ALL SEASON (in %)",
    tyreSizes: "Number of storages per season (tire sets)",
    diffDeliveryAddres: "Add delivery address",
    yourEmailAddress: "Your email address*",
    clientNr: "Client numbers",
    clientNrSingular: "Client number",
    clientNrContent:
      "<span class='text-danger fw-bold'>IMPORTANT - PLEASE READ:</span><br /><br /> It is <b>essential that you provide your respective client numbers</b> for the allocation of your tire orders at the wholesaler and / or at Bridgestone.<br/><br/>If you have <b>multiple client numbers at a wholesaler and / or at Bridgestone,</b> for example for your main store and your branches, please provide the client number of your main store first.<br/><br/><b>The sales of the other client numbers will then be allocated to your main store.</b>",
    supplySource: "Source of supply",
    email: "Email address",
    staffEmail: "Participant email address",
    registered: "Registered on",
    registeredAt: "Registered on",
    lastLogIn: "Last login",
    details: "Details",
    inDetail: "{name} in detail",
    bsClientNr: "Your Bridgestone customer number",
    bftClientNr: "Your Best4Tires customer number",
    acceptTerms: "Accept terms and conditions.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>IMPORTANT - PLEASE READ:</span><br />When you provide your customer number for the first time, your details will be checked for accuracy and in accordance with our sales criteria. The decision to activate your customer number(s) and link it to your profile may take up to 5 working days.",
    selectWholeSaler: "at supplier (please select)",
    cooperation: "MEMBER / COOPERATION",
    error100: "The sum of the values must be 100%.",
    errorRange: "The value must be between 0 and 100.",
    btw_number_label: "VAT identification number of your company",
    btw_number: "VAT identification number",
    mobile: "MOBILE NUMBER",
    mobile_label: "Your (mobile) phone number",
    iban_number: "IBAN number of your company",
    iban_number_label: "IBAN number",
    yourCsNr: "Your customer numbers",
    yourLastName: "Your last name",
    positionLabel: "Select position",
    yourFirstName: "Your first name",
    companyLabel: "Company",
    numberOfSetsOfSeasonalTiresBudget:
      "Number of sets of seasonal tires per year",
    tireSaleDetail: "Tire sales per year",
    contactInfo: "If you have any questions, please contact:",
    addAnotherCsNumber: "add another bridgestone customer number",
  },
  pobox: {
    title: "My Inbox",
    desc: "Welcome to your personal area. Here you can add or modify your contact information, view your inbox, and view your points account statement.",
    message: {
      sender: "Sender",
      thread: "Thread",
    },
    sender: {
      system: "BRIDGESTONE PLUS",
    },
    back: "Back to overview",
  },
  time: {
    secondsAgo: "{time} seconds ago",
    minutesAgo: "{time} minutes ago",
    hoursAgo: "{time} hours ago",
    daysAgo: "{time} days ago",
  },
  bankstatement: {
    title: "My personal bank statement",
    desc: "Here you can view your personal Bridgestone Plus account statement showing the reward points you have received and used. Please note that, depending on the source, points credits for your tire order will only be credited up to 6 weeks after the order was placed.",
    score: "Score",
    regularPoints: "Regular points",
    boosterPoints: "Booster points",
    date: "Date",
    supplySourceReason: "Source/reason",
    article: "Article",
    brand: "Brand",
    product: "Product",
    type: "Type",
    inch: "Inch",
    season: "Season",
    amount: "Amount",
    standardPoints: "Points",
    boosterProduct: "Booster Product",
    boosterSeason: "Booster Season",
    otherActions: "Other action or cause",
    totalPoints: "Total points",
    income: "Accesses",
    spending: "Departures",
    lastMonth: "Stand at the end",
    loadMore: "Load another 20 turnovers",
    typeFilter: "Filter by source",
    dateFilter: "Filter by date range",
    customer_number: "CsNr.",
    currentPoints: "Current points",
    calculationDate: "Calculation date",
    positivePoints: "Positive points",
    negativePoints: "Already issued",
    tyresAmount: "Tire quantity annually",
    pointsTotal: "Total points",
    currentPointState: "Current points state",
    currentKickbackState: "Current kickback state",
    pointsFromCurrentYear: "Add: points from current year ({year})",
    pointsAtRiskOfExpiry: "Points to spend by 31.03.{year}",
  },
  shop: {
    description:
      "Welcome to the rewards shop. Here you can redeem your Bridgestone Plus points <br/> for rewards from various categories. The range of products <br/> is updated regularly. We hope you enjoy browsing.",
    selectedProducts: "Selected products",
    selectedAddress: "Selected address",
    noProducts: "The search criteria returned no hits",
    placeOrder: "Binding order",
    toOrderDelivery: "Continue to the delivery address",
    toOrderSummary: "To the order overview",
    emptyCart: "Shopping cart is empty.",
    pointsTotal: "Total points",
    productImg: "Product image",
    selectAddressBtn: "choose address",
    selectAddressP: "Please select your delivery address",
    notEnoughPoints: "Not enough points available.",
    outOfStock: "Currently not on stock",
    timeUnavailable: "Currently not available at the time",
    productUnavailable: "This product is no longer available.",
    deletedProductsTitle: "Products no longer available",
    deletedProductsMessage:
      "The following product(s) are no longer available. Remove them from your cart to continue.",
    removeSelected: "Remove selected",
    clearCart: "Clear cart",
    removeSelectedConfirm: "Remove the selected products from your cart?",
    clearCartConfirm: "Remove all products from your cart?",
    cart: {
      pointsPerUnit: "Points/Unit",
      pointsSum: "Points",
    },
    sort: {
      asc: "Sort by: Lowest Price",
      desc: "Sort by: Highest Price",
    },
    perPgae: "Items per page",
    categories: {
      advertising: {
        title: "Advertising Materials",
        desc: "Participate directly here on the platform and secure <br/> 40 extra points for the rewards club.",
      },
      rewards: {
        title: "Exclusive rewards",
        desc: "Discover the bonus offer in our training center or at your location.",
      },
      tools: {
        title: "Workshop tools",
        desc: "Use your points for third-party <br/> training and reduce your costs.",
      },
      trainings: {
        title: "Training and education",
        desc: "Discover the bonus offer in our training center or at your location.",
      },
      salesroom: {
        title: "Salesroom",
        desc: "Stage the sales room and offer your customers a pleasant stay.",
      },
      hunter: {
        title: "Hunter",
        desc: "Exchange points for attractive workshop equipment from Hunter.",
      },
    },
    bestSold: "Best-selling",
    seasonal: "Seasonal",
    affordable: "Almost there",
    forPoints: "for {points} points",
    reachedPoints: "Required points reached",
    cartRemainPoints: "Points remaining",
    remainingPoints: "{points} Points remaining",
  },
  externeTraining: {
    title: "External training",
    description:
      "Get expert knowledge and, if you successfully complete the respective training tests, your personal certificate of participation and a one-off 40 extra points for the rewards club",
    additionalInfo:
      "In addition to our free online training courses and the paid Bridgestone training courses, we also offer you the opportunity to finance or subsidize external training courses with your reward points - depending on your credit.",
    itsEasy: "It's that easy:",
    excludeText:
      "Please understand that offers from direct competition are excluded.",
    downloadSection: {
      title: "Download invoice template",
      description1: "Download a template for your points statement to us here.",
      description2:
        "On the example you will find all the information you need.",
    },
    form: {
      title: "Application",
      thirdPartyInvoice: "Third party invoice",
      userInvoice: "My bill",
      bankAccountOwner: "Account owner",
      uploadInvoice: "Upload my invoice for the points used",
      have: "I would like",
      thirdPartyInvoiceDesc:
        "Points in a %{calculatePriceDiscount} EUR of for the following",
      userInvoiceDesc: "Use training invoice, upload third-party invoice",
    },
    info: {
      paragraph1:
        " You or your team take part in technical training provided by a third-party provider.",
      paragraph2: "They settle the third-party invoice.",
      paragraph3:
        "You can submit an application for a subsidy in the inquiry field here on this page",
      elements: {
        first: "Upload third party invoice",
        second:
          "Enter the amount of points you would like to use (maximum the amount of the net invoice amount)",
        third:
          "You create an invoice for your company in the amount of the points used (0.25 EUR net per point) and also inflate this",
        fourth: "The invoices and the application are checked",
        fifth: "You will receive a payout equal to the points you staked",
      },
    },
    success: {
      title: "Thank you",
      paragraph: {
        first: "Your application has been received.",
        second:
          "After successful verification, the refund in the amount of the points used will be credited to the specified account.",
        third: "Verification and payment may take up to 6 weeks.",
        fourth:
          "We have reduced your points account by the amount of the points used.",
        fifth: "You can find a copy of the application in your",
      },
    },
  },
  buttons: {
    toSearch: "Search",
    sendRequest: "Send request",
    formButton: "To form",
    discover: "Discover",
    sendButton: "Submit",
    makeContact: "Get in touch",
    userProfile: "To your contact information",
    userOrders: "To your orders",
    mailbox: "To inbox",
    pointsList: "To statement",
    next: "Next",
    back: "BACK",
    skip: "Skip",
    toTheBasket: "Add to cart",
    edit: "Edit",
    cancel: "Cancel",
    select: "Select",
    newOrder: "New order",
    downloadAll: "Download all",
    readNow: "Read now",
    toDashboard: "To homepage",
    moreCustomerNumbers: "+ ADD MORE CUSTOMER NUMBERS",
    toProductInfo: "DISCOVER PRODUCT INFORMATION",
    toAccount: "TO POINTS ACCOUNT",
    toSalesPromotions: "SIGN UP YOUR BUSINESS NOW",
    show: "DISCOVER NOW",
    toOnlineTrainings: "TO ONLINE TRAININGS",
    newAddress: "Create new delivery address",
    toQuiz: "To quiz",
    toDownload: "To download",
    calculate: "Calculate",
    reset: "New calculation",
    register: "Register",
    refuseBtn: "DECLINE",
    acceptBtn: "ACCEPT",
    toCommitmentLetter: "TO COMMITMENT LETTER",
    toKickbackFeeInfo: "TO EXPLANATION OF FEE & POINTS",
    clickHere: "View details",
    directBuy: "Direct buy",
    toDiscover: "To discover",
    dealerInfoDownload: "DOWNLOAD DEALER INFORMATION",
    all: "All",
    clearFilters: "Clear filters",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    downloadSelection: "Download selection",
    preview: "Preview",
    vouchers: "To the points overview",
    exchangeVoucher: "Redeem voucher code",
    confirm: "Confirm",
  },
  myAccount: "My account",
  menu: {
    account: "My Account",
    plus: 'About Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Sales Support",
    mailbox: "Inbox",
    about: "About BS Plus",
    trainingAndCourses: "Trainings & Courses",
    externalTraining: "External Trainings",
    productInfo: "Product Information",
    productBrochures: "Product Brochures",
    priceLists: "Price Lists",
    price: "Price",
    complaintForm: "Complaint Form",
    sales_support: "Sales Support",
    contact_service: "Contact & Service",
    logOut: "Log Out",
    news: "News",
  },
  productInfo: {
    categories: {
      info: "Product information",
      priceList: "Price lists",
      contact: "Contact",
    },
    page: {
      description:
        "Welcome to the information area about Bridgestone & Firestone products.<br/>Here you will find current brochures and price lists, as well as helpful links and forms.",
    },
    index: {
      title: "Product Information",
      description:
        "Welcome to the information area about Bridgestone and Firestone products.<br/>Here you will find current brochures and additional materials.",
      categories: {
        productBrochures: {
          title: "Product Brochures",
          description:
            "Download the latest Bridgestone and Firestone product brochures.",
        },
        bDrive: {
          title: "Tire Images &<br/>Logos",
          description:
            "Download the latest logos, product images, and marketing templates.",
        },
        calculator: {
          title: "Fuel Savings<span class='text-danger'>-Calculator</span>",
          description:
            "Simply calculate the potential savings with tires with optimized rolling resistance!",
        },
      },
    },
  },
  productList: {
    pkw: {
      title: "Price lists for passenger cars, 4x4 vehicles, and vans",
      description:
        "Download the latest price lists for our Bridgestone and Firestone tires here: <ul><li>Passenger cars, 4x4 vehicles, and vans</li></ul>",
    },
    trucksAndBuses: {
      title: "Price lists for trucks and buses",
      description:
        "Download the latest price lists for our Bridgestone and Firestone tires here: <ul><li>Trucks and buses</li></ul>",
    },
    motorcycles: {
      title: "Price lists for motorcycle tires",
      description:
        "Download the latest price lists for our Bridgestone tires here: <ul><li>Motorcycles</li></ul>",
    },
    agriculture: {
      title: "Price lists for agricultural tires",
      description:
        "Download the latest price lists for our Bridgestone and Firestone tires here: <ul><li>Agricultural vehicles</li></ul>",
    },
    constructionMachineryOtr: {
      title: "Price lists for construction machinery and OTR tires",
      description:
        "Download the latest price lists for our Bridgestone and Firestone tires here: <ul><li>Construction machinery and OTR</li></ul>",
    },
    main: {
      title: "Price lists",
      description:
        "Download the latest price lists for our Bridgestone and Firestone tires here: <ul><li>Passenger cars, 4x4 vehicles, and vans</li><li>Motorcycles</li><li>Trucks and buses</li> <li>Agricultural vehicles</li><li>Construction machinery and OTR</li></ul>",
    },
    index: {
      description:
        "Welcome to the price list section for Bridgestone and Firestone products.<br/>Here you will find the latest price lists for all product categories and price files for your inventory management system.",
    },
  },
  productBrochures: {
    desc: "Download the latest brochures and flyers for our Bridgestone and Firestone tires for passenger cars, SUVs, and vans.",
    technologiesTitle: "Technologies, markings, and more",
    technologiesDesc:
      "Download the latest brochures and flyers for our technologies, markings, and more for passenger cars, SUVs, and vans.",
    BDriveTitle: "Tire images & logos",
    BDriveDesc:
      "Download profile images, logos, and more for all product categories and brands.",
    BDriveLinkText: "Link to the TIRE IMAGES & LOGOS portal",
  },
  contact: {
    index: {
      title: "Contact & Service",
      description:
        "Welcome to the Service section of BRIDGESTONE PLUS. Here you will find contact information for the Service team, as well as the opportunity to submit product complaints via a form.",
    },
    categories: {
      service: {
        description: "Service number for your region and email contact",
      },
      form: {
        description: "Submit product complaints directly here via the form",
      },
    },
    form: {
      intermediaryAddress: "Address of the intermediary",
      nameFirma: "Name / company",
      strHouseNr: "Street & house number",
      contactPerson: "Contact person",
      vehicleDetails: "Vehicle details",
      vehicleTyres: "Vehicle/tires*",
      brandNew: "New (not mounted)",
      newItem: "New (mounted)",
      fwd: "Front-wheel drive",
      rwd: "Rear-wheel drive",
      awd: "All-wheel drive",
      vehicleManufacturer: "Vehicle manufacturer",
      vehicleModelType:
        "Vehicle model and type designation according to registration",
      firstRegistration: "First registration (DD.MM.YYYY)",
      enginePower: "Engine power (KW, e.g. 150)",
      originalEquipment: "Original equipment",
      tireMilageHours: "Tire mileage (km) / operating hours",
      tireMilage: "Tire mileage (km)",
      tireHours: "Operating hours",
      mileageOrHours: "Km or hours (e.g. 2000)",
      copyTire1: "Copy tire 1",
      copyTire3: "Copy tire 3",
      damageDetails: "Damage details",
      complaintReason: "Complaint reason*",
      vibration: "Vibration",
      notBalancable: "Unbalanceable",
      sounds: "Sounds",
      airPressureLost: "Air pressure loss",
      worn: "Worn pattern",
      runningPerformance: "Tread life",
      deformation: "Dents / deformations",
      profileBreakouts: "Tread breaks",
      cracks: "Cracks",
      drivingBehavior: "Driving behavior",
      pull: "Pulling",
      wetGrip: "Wet grip",
      defective:
        'Defective new tires (please specify delivery note number under "Complaint reason text")',
      otherReason:
        'Other reason (please specify under "Complaint reason text")',
      isTyreReplaced: "Were the tires already replaced?*",
      ifYesTyre: "If yes, brand of replacement tires",
      clerkName: "Name of the clerk*",
      conclusion: "Conclusion",
      conclusionContent:
        "<p>These details are complete and have been made to the best of my knowledge.<br/>It is ensured that the tires complained about were driven on the aforementioned<br/>vehicle. <br /><br /><b>The tires can be cut for testing purposes. </b><br /><br /><b>In the event of a complaint being upheld, we reserve the right to reimburse the<br/>tires after a pro rata credit, or to compensate for them by<br/>a free replacement delivery.<br/></b><br />The recognized tires will be scrapped. In case of rejection, it can be<br/>requested back. <br /><br />The storage of the aforementioned personal data is permitted.<br/></p>",
      agreementReadAccept: "Agreement read and accepted.*",
      termsConditionsRead: "Read the terms and conditions.",
      termsConditionsReadAccept: "Terms and conditions read and accepted.*",
      send: "Submit",
      requiredField: "*Required field",
      tires: "Tires",
      notKnown: "Not known",
      carSUVTractor: "PKW/SUV/TRAKTOR",
      CSTFrontLeft: "P/S/T-front left",
      CSTFrontRight: "P/S/T-front right",
      CSTRearLeft: "P/S/T-rear left",
      CSTRearRight: "P/S/T-rear right",
      motorcycle: "MOTORRAD",
      motFront: "MOT-front",
      motRear: "MOT-rear",
      truck: "LKW SZM",
      truckSteeringAxle1Left: "Truck steering axle 1 left",
      truckSteeringAxle1Right: "Truck steering axle 1 right",
      truckSteeringAxle2Left: "Truck steering axle 2 left",
      truckSteeringAxle2Right: "Truck steering axle 2 right",
      truckDriveAxle1LeftInner: "Left inner axle of drive axle 1 of truck",
      truckDriveAxle1LeftOuter: "Left outer axle of drive axle 1 of truck",
      truckDriveAxle1RightInner: "Right inner axle of drive axle 1 of truck",
      truckDriveAxle1RightOuter: "Right outer axle of drive axle 1 of truck",
      truckDriveAxle2LeftInner: "Left inner axle of drive axle 2 of truck",
      truckDriveAxle2LeftOuter: "Left outer axle of drive axle 2 of truck",
      truckDriveAxle2RightInner: "Right inner axle of drive axle 2 of truck",
      truckDriveAxle2RightOuter: "Right outer axle of drive axle 2 of truck",
      truckTrailingAxleLeft: "Left trailing axle of truck",
      truckTrailingAxleRight: "Right trailing axle of truck",
      trailerSemi: "Trailer/semi-trailer",
      trailerAxle1LeftOuter: "Left outer axle of trailer axle 1",
      trailerAxle1LeftInner: "Left inner axle of trailer axle 1",
      trailerAxle1RightOuter: "Right outer axle of trailer axle 1",
      trailerAxle1RightInner: "Right inner axle of trailer axle 1",
      trailerAxle2LeftOuter: "Left outer axle of trailer axle 2",
      trailerAxle2LeftInner: "Left inner axle of trailer axle 2",
      trailerAxle2RightOuter: "Right outer axle of trailer axle 2",
      trailerAxle2RightInner: "Right inner axle of trailer axle 2",
      trailerAxle3LeftOuter: "Left outer axle of trailer axle 3",
      trailerAxle3LeftInner: "Left inner axle of trailer axle 3",
      trailerAxle3RightOuter: "Right outer axle of trailer axle 3",
      trailerAxle3RightInner: "Right inner axle of trailer axle 3",
      DOT: "DOT (please specify all 10-11 digits)",
      TruckSerialNo: "Serial number (only for truck tires)",
      complaintReasonText: "Complaint reason text",
      csNumberIfNeed: "Customer number (if available)",
    },
    teams: {
      tyre: "Team Tyre dealer",
      car: "Team Car dealer",
    },
    carDealers: {
      title: "Your personal contact at Bridgestone",
    },
  },
  mainPage: {
    categories: {
      productInfo: "Product information",
      salesSupport: "Sales support",
    },
  },
  fireStoneProducts: {
    title: "Firestone products",
    description:
      "Two quick boxers chase the lively Eva and her pug through Sylt. Franz hunts across Bavaria in a completely dilapidated taxi. Twelve boxers chase Viktor across the great Sylt dike. Bird Quax pinches Johnny's horse Bim.",
    files: {
      summer: {
        title: "VANHAWK MULTISEASON",
        description: "Transporter - All Season",
        date: "Product overview 2021",
      },
      winter: {
        title: "WINTERHAWK 4",
        description: "Pkw, SUV - Winter",
        date: "Product overview 2020",
      },
    },
  },
  complaintForm: {
    title: "Complaint form",
    description: "Fill out the following form for complaints about our tires:",
    sections: {
      generally: {
        title: "generally",
      },
      regulator: {
        title: "Address tire dealer - regulator",
      },
    },
    fields: {
      ordinance: "Retailer's ordering term",
      ifAvailable: "(if available)",
      companyName: "Name (company)",
    },
  },
  salesPromotions: {
    title: "Sales promotion",
    desc: "With our sales promotion campaigns for Bridgestone and Firestone, we actively support you in sales discussions and provide you with additional arguments. If you also want to use promotions for your business, you can find out more on this page and apply to participate as a trading partner",
    bonusCampaign: {
      title:
        '<span class="font-sm">Bridgestone bonus promotion</span><br/><h3 class="fw-bold">DRIVE<span class="text-danger">OUR</span>BEST</h3>',
      desc: "As part of the DRIVE OUR BEST campaign, customers receive a voucher worth up to 40 EUR when they purchase at least 2 Bridgestone premium tires from participating retailers. The voucher can be redeemed at attractive partners such as Amazon, Aral/OMV, MediaMarkt, REWE, Shell, Zalando, etc.<br/><br/>The value of the voucher depends on the number of tires purchased and their size in inches.",
    },
    guarantee: {
      title:
        'Bridgestone tire warranty<br/><h3 class="fw-bold">TYRE<span class="text-danger">PROTECT</span></h3>',
      desc: "Drive-in damage and damage caused by curbs - what was previously associated with frustration and annoyance, has been successfully solved by Bridgestone digitally, in a dealer- and customer-friendly manner since 2020, with a two-year tire guarantee.<br/><br/>Depending on the age of the insured Bridgestone tire, your customer will receive... In the event of damage, up to 100% of the purchase price for the replacement tire will be refunded.<br/><br/>Now new from 2023: Your customers can claim the guarantee when purchasing 2 or more tires of all inch sizes. ",
    },
    premium: {
      title:
        'Firestone premium & warranty<br/><h3 class="fw-bold">REIFEN<span class="text-danger">HITS</span></h3>',
      desc: "As part of the FIRESTONE REIFENHITS campaign, buyers of at least 2 Firestone tires receive not only a 24-month tire warranty that covers damage such as curb or run-in damage, but also an entertainment voucher from BestChoice worth up to 20 EUR.<br/><br/>New for 2023: Participation is now possible with the purchase of 2 passenger car, SUV, or van tires of any size.",
    },
    participation: {
      title: "Apply now",
      desc: "Do you want to implement one or more of our campaigns in your store? Then you can apply for your participation here. Your business will be unlocked for the campaign(s) and you will receive campaign material for your sales area within 4 weeks.<br/><br/>Make your selection:",
      success: "Thank you, your request has been sent",
      bonusCampaign:
        '<span class="fw-bold">DRIVE<span class="text-danger">OUR</span>BEST</span> - The Bridgestone bonus campaign',
      guarantee:
        '<span class="fw-bold">TYRE<span class="text-danger">PROTECT</span></span> - Bridgestone tire warranty',
      advantage:
        '<span class="fw-bold">REIFEN<span class="text-danger">HITS</span></span> - The Firestone premium campaign with additional tire warranty',
      premium:
        '<span class="fw-bold">REIFEN<span class="text-danger">HITS</span></span> - The Firestone premium campaign with additional tire warranty',
      request: "Apply for participation",
    },
  },
  trainings: {
    seasons: {
      all: "All Season",
      summer: "Summer",
      winter: "Winter",
      general: "General",
    },
    offer:
      "We regularly expand our <br />offers for you! <br /><br />We will inform you about new training courses in your inbox.",
    summary: {
      congratulations: "CONGRATULATIONS - YOU HAVE COMPLETED YOUR EXPERTISE ON",
      participation:
        "You have successfully completed the Transporter All-Season Tires Online Training.",
      certificate:
        "Your certificate will be sent to you by email or you can download it directly as a PDF here:",
      send: "Download certificate",
    },
    online: {
      title: "Our online trainings",
      desc: "Secure expert knowledge and, upon successful completion of the respective tests for the training, your<br> personal participation certificate as well as 40 extra points for the premium club for the first time",
      content:
        "Discover our current online trainings now and participate immediately on the platform here:",
    },
    lectures: {
      title: "Bridgestone trainings",
      desc: "Expand your expertise and book our trainings and intensive trainings for yourself and your team. You have the option of participating in the trainings at the Bridgestone Competence and Training Center in Dietzenbach (near Frankfurt am Main) or, for selected trainings, having them carried out at your company. You can use your bonus points for the trainings and thus offset the costs in whole or in part with your points.",
      content: "Discover our current trainings now and request a booking:",
    },
    singleLecture: {
      registerForm: {
        title: "Training contents",
        inquiry: "Inquiry",
        interested: "I am interested in the training",
        participantsNr: "Number of participants",
        pointsFromBalance: "I want to use points from my points balance.",
        reduction: "This corresponds to a cost reduction of {points} euros.",
        request: "Send request",
      },
      success: {
        thanks: "Thank you",
        title: "Your inquiry has been sent to the training team.",
        feedbackTime:
          "You will receive a response within 14 days to clarify all details.",
        points:
          "The bonus points used in the amount of<br /><strong>{points}</strong> points have been deducted from your<br />points account.",
        refund:
          "If the training does not take place, the points will of course be credited back to you.",
        queries: "For questions, please contact:",
      },
      index: {
        costs: "Costs and participation information",
        duration: "Duration: {duration}",
        cost: "Costs {cost}: {price} euros",
        participantsNr: "Participants: min. {min} - max. {max} people",
      },
    },
    index: {
      title: "Training and education",
      desc: "Advantage through knowledge: Secure exclusive specialist knowledge for you and your team with our training offers. Whether with our online training, which you can take part in directly on the platform, with our training and practical seminars in the Bridgestone training center or with external training, the costs of which you can reduce with your reward points.",
      online: {
        title: "Online trainings",
        desc: "Participate directly on the platform and secure {points} points for the premium club.",
      },
      lectures: {
        title: "Trainings",
        desc: "High-quality trainings in our training center or at your location.",
      },
      external: {
        title: "External trainings",
        desc: "Use bonus points for offers from third-party providers and reduce costs.",
      },
    },
  },
  salesSupport: {
    title: "Sales support",
    desc: "We offer you various measures and campaigns to actively support your sales - from a strong sales promotion campaign to an attractive sales room to individual support.",
    salesPromotions: {
      title: "Sales promotion",
      desc: "Attractive extras and guarantees for your customers when buying tires.",
    },
    displaysFurniture: {
      title: "Displays & furniture",
      desc: "Get high-quality equipment for your sales room with your bonus points.",
    },
    individualSupport: {
      title: "Individual support",
      desc: "Secure individual support with your bonus points.",
    },
  },
  serviceNumber: {
    title: "Contact and service numbers",
    subtitle: "Your personal contact at Bridgestone",
    description:
      "We are always here for you! Find your personal Bridgestone contact person for your region here or simply contact our competent employees in customer service.",
    manager: "Sales Manager Germany",
    yourCustomerService: "Your Customer Service",
    generalCustomerService: "Customer Service in general",
    salesTerritory: "Sales Territory",
    carDealer: "Car Dealership",
    centralEmail: "Central e-mail contact",
    sales_manager: "Sales manager Netherlands",
    contact_person: "Bridgestone plus contact person",
    sales_representative: "Sales representative",
    key_account: "Key Account Manager",
    warranty: "Warranty",
    car_releases: "Car releases",
    motorcycle_releases: "Motorcycle-releases",
    commercial_vt: "Commercial vehicle tires",
    agricultural_tires: "Agricultural tires",
  },
  directions: {
    west: "West",
    north: "North",
    east: "East",
    south: "South",
  },
  training: {
    title: "Certificate and {points} extra points for you!",
    subtitle:
      "Secure your personal participation certificate and an additional {points} extra points for the bonus club.",
    description:
      "How? It's simple: successfully complete the test on the training after the video! The test will appear as soon as you have watched the video in full!",
  },
  about: {
    title: "About Bridgestone <span class='text-danger'>Plus</span>",
    description:
      "YOUR <span class='text-danger'>PLUS</span> WITH BRIDGESTONE - this is our guiding principle of the entire BRIDGESTONE <span class='text-danger'>PLUS</span><br/>program for our trading partners. Discover the numerous exclusive advantages.",
    sections: {
      first: {
        title: "Excellent products in the premium and quality segment",
      },
      second: {
        title: "Attractive rewards program",
      },
      third: {
        title: "Effective sales support",
        description:
          "Expanded options for exclusive shopping experiences and your digital presence at relevant Touchpoints.",
        subtitle: "Our proven sales promotions",
        pointInfo:
          "Benefit from additional sales arguments and your customers from exciting bonus and added value promotions.",
        numberInfo:
          "Digital direct processing with your customer – no additional effort for you!",
        subtitle2: "Strong appearance with our sales room equipment",
        description2:
          "Present your sales room attractively and offer your customers a pleasant stay with our modules for counter areas, exhibition areas, waiting and outdoor areas as well as digital solutions!",
        description3: "Collect points and <b>promote your company</b> with us",
      },
      fourth: {
        title: "EVERYTHING ON ONE PLATFORM: THE BRIDGESTONE PLUS PORTAL",
        description:
          "With your personal access to the online portal you have direct access to the diverse range of BRIDGESTONE <span class='text-danger'>PLUS</span>.",
        list: {
          program: "Points program",
          shop: "Bonus shop",
          priceList: "Price lists",
          productInfo: "Product information",
          salePromotion: "Sales support",
          onlineTrainings: "Online training",
          andMore: "and much more.",
        },
        title2: "Regular online training",
        description2:
          "Always stay up to date and benefit from Bridgestone online training together with your team ",
      },
      points: {
        title:
          "Current online training courses in the areas of products and sales:",
        list: {
          one: "Sales training",
          two: "Framework constructions",
          three: "Identifying damage patterns",
        },
        subtitle: "YOUR PARTICIPATION WILL BE REWARDED",
        description:
          "You will receive <b>40 points</b> and a <b>certificate of participation</b> for every completed online training!",
      },
    },
    fullPremium:
      "The entire Bridgestone passenger car premium range for the replacement market was consistently rated “A” in the wet grip area.</strong>",
  },
  her: "Her",
  seasons: {
    summer: "Summer",
    winter: "Winter",
    all: "All Seasons",
  },
  loginPage: {
    title: "Log in",
    resetTitle: 'Welcome to BRIDGESTONE <span class="text-danger">PLUS</span>',
    desc1:
      'You have already successfully logged in to the BRIDGESTONE <span class="text-danger">PLUS</span> portal.',
    desc2: "If so, log in with your email address and password.",
    desc3: "Log in with your email address and password.",
    resetSubTitle:
      'Are you a Bridgestone TYRE<span class="text-danger">CLUB</span> participant?',
    resetDesc:
      "If so, first reset your new password for the email address you used for the TYRE<span class='text-danger'>CLUB</span> using the <b>Forgot password</b> function.",
    footer: "You will then be automatically logged in.",
    resetNewPass: "SET NEW PASSWORD",
    noAccount: "I don't have an account yet",
    error: "Invalid login credentials, please try again!",
    logWithAzure: "Log in with Azure",
  },
  maintenance: {
    title: "Maintenance!",
    desc: 'Currently, necessary maintenance work is being carried out on the servers.<br/><br/>Therefore, you currently do not have access to <b>BRIDGESTONE <span class="text-danger">PLUS</span></b>.<br/><br/>We ask for your patience and thank you for your understanding.<br/><br/>Your Bridgestone Team',
  },
  contactPage: {
    title: "Complaint form",
    description:
      "Please fill out the following form to report a complaint about our tires:",
    damage: "Property damage",
    personalInjury: "Personal injury",
  },
  yesText: "yes",
  noText: "no",
  wrongFileError: "The required file format is PDF",
  toastMessages: {
    fleetWithOptions: "You cannot choose fleet if you have selected options",
    addProduct: "Your product has been added to your cart.",
    addProducts: "Your products have been added to your cart.",
    profileSaved: "Your profile information has been saved.",
    canAddProduct: "You don't have enough points.",
    customerNumberSaved: "Customer number saved.",
    customerNumberExist: "Customer number already exists.",
    complaintForm:
      "Your request has been accepted. Please wait for a response.",
    changeParentId:
      "You cannot change the branch with the parent customer number if it has subordinate branches.",
    requestSent: "Request has been sent",
    completeProfileRequired:
      "You should complete profile with 100% to proceed buy in shop.",
    accessDenied: "Access denied",
    incomplete_address: "Address is incomplete. Please check",
    waitMoment: "Wait a moment",
    favoriteAdded: "Added to favorites.",
    favoriteRemoved: "Removed from favorites.",
    downloadFinished: "Download finished",
    selectOneField: "Select one field",
    noVoucher: "Voucher was not found",
    cannotAddCsNumber: "You cannot add customer number",
  },
  order: {
    number: "Order no.",
    createdDate: "Ordered on",
    description: "Here you will find an overview of your reward shop orders.",
    success:
      "Thank you! Your order was successful. You will receive an order confirmation in your inbox in just a few minutes.",
    anyOrder: "No orders",
    shippedAt: "Shipped at",
    sku: "SKU",
    status: {
      created: "Created",
      confirm_order: "Confirm order",
      ready_for_shipment: "Ready for shipment",
      rejected: "Rejected",
      processed: "Processed",
      shipped: "Shipped",
      returned: "Returned",
      finished: "Finished",
    },
    details: {
      title: "Order details",
      description: "Review and manage new orders",
    },
    date: "Order date",
    products: "Products",
    quantity_short: "pcs",
  },
  orders: "Orders",
  hunter: {
    title: "Hunter",
    description:
      "High-quality machines and equipment for your workshop are an investment in your business success. Use your BRIDGESTONE <span class='text-danger'>PLUS</span> bonus points to make the purchase of HUNTER workshop machines more affordable. The bonus points you use will be directly deducted from HUNTER and will affect the purchase price accordingly.",
    priceInfo: "Net price including freight and commissioning/training",
    pointsInfo: "Net price in points",
    investInfo:
      "It is possible to deduct or credit points via investment support.",
    contactInfo:
      "If you have any questions about the process, please contact us personally. Contact",
    specification: "Specifications",
    pointDiscount: "This corresponds to {price} EURO",
    form: {
      title: "I am interested in",
      subtitle: "I would like to use points from my points balance",
      description:
        "After submitting your request, we will contact you. Of course, we are also always available to answer your questions.",
    },
  },
  intro: {
    step1: {
      title: "Personal information",
      description:
        "Here you will find information about your Plus account and your Plus mailbox.",
    },
    step2: {
      title: "Points overview",
      description:
        "Here you will find your points overview. You can view your performance over the past twelve months and secure rewards with points.",
    },
    step3: {
      title: "Stay up-to-date",
      description:
        "Let Bridgestone Plus explain the features and learn what else is possible.",
    },
  },
  wholesaler: {
    dashboard: {
      title: "{name} Dashboard",
      extraTitle: "WHOLESALER-DASHBOARD",
      description:
        "Welcome to your dashboard. Here you can view current key figures and participating businesses from your customer base.",
      overview: {
        title: "Overview of participating customers",
        description:
          "Businesses that have registered with BRIDGESTONE PLUS and that we can assign to your company via the customer number.",
        month: "New this month",
        year: "New this year",
        all: "Total",
      },
      credits: {
        title: "Points credits {name}",
        description:
          "Bonus points assigned to participating businesses based on the sales figures you uploaded. This view shows regular points without special promotions.",
        month: "Last month",
        year: "Current year",
        prev_year: "Total",
        all: "Total",
        allDealers: "All dealer points",
      },
      details: {
        title: "Details of participating customers",
        description:
          'The following businesses are listed that have registered on BRIDGESTONE <span class="text-danger">PLUS</span> with a {name} customer number and that are assigned to you as the responsible person. Simply use sorting functions for a different tire sequence or the search mask.',
      },
      lastImport:
        "Last import of sales figures: <br/> <span class='text-danger'>{date}</span>",
      loadMore: "Load more 20 dealers",
      tyres: {
        title: "Tires",
        description: "Tires purchased by program participants",
      },
    },
  },
  staff: {
    dashboard: {
      title: "Outside Sales Dashboard",
      description:
        "Welcome to your dashboard. Here you can view current key figures and participating businesses from your customer base.",
      overview: {
        title: "Overview of participating customers",
        description:
          "Businesses that have registered with BRIDGESTONE PLUS and that we can assign to you via the customer number.",
        month: "New this month",
        year: "New this year",
        all: "Total",
      },
      credits: {
        title: "Points credits",
        description:
          "Bonus points assigned to participating businesses based on the sales figures you submitted.",
        month: "Last month",
        year: "Current year",
        prev_year: "Total",
        allDealers: "All dealer points",
        allPoints: "All points",
      },
      details: {
        title: "Details of participating customers",
        description:
          'The following businesses are listed that have registered on BRIDGESTONE <span class="text-danger">PLUS</span> with a Bridgestone customer number and that are assigned to you as the responsible person. Simply use sorting functions for a different tire sequence or the search mask.<br/><br/> <b>Note:</b> If you click on the points balance, you will be taken to the detailed account statement.',
      },
      lastImport:
        "Last import of sales figures: <br/> <span class='text-danger'>{date}</span>",
      kickback: {
        description:
          "Kickback fees will be credited to participating companies based on the submitted sales figures.",
      },
      tyres: {
        title: "Tires",
        description: "Tires purchased by program participants",
      },
    },
  },
  newsFeed: {
    more: "More information at",
  },
  investment: {
    title: "Investment support",
    description:
      "Bridgestone also supports you individually in your business investments. Whether for the purchase of machines or workshop equipment, for workshop replacement vehicles or also for marketing activities such as advertising or online banner placements, etc. - use your BRIDGESTONE PLUS bonus points to refinance your investments. Simply submit the invoice from the respective supplier here after the investment and indicate how many of your bonus points you would like to use here. Follow the instructions described below.",
    description_old:
      "Investment support for workshop equipment Advertising grant for marketing projects",
    info: {
      paragraph2_old:
        "Bring your workshop equipment or sales area up to date or advertise to better market your products. Please tell us the points value that you would like to contribute for this prize. The minimum points expenditure is 1,250 points. Value per point = 0.25 EUR",
      paragraph2:
        "You implement your desired investment and settle the invoice from the third-party provider.",
      paragraph3_old:
        "To invoice the prize, we need your invoice for the amount of the redeemed points (number of points x 0.25 € = net invoice amount) and a copy of the original invoice. You can find a sample invoice",
      paragraph3:
        "Finally, you submit the application for funding here on this page in the request field on the right",
      paragraph4_old:
        "We ask you to contact us personally to initiate the next steps.",
    },
    excludeText:
      "Please understand that investments in direct competitive offers are excluded.",
    here: "here",
    contactPerson: "Contact person",
    email: "Email",
    phone: "Tel",
    payInfo: "Payment may take up to 8 weeks!",
  },
  notice: "Notice",
  noticeDescription:
    "In case of property damage and/or personal injury, please contact Bridgestone Europe NV/SA Niederlassung Deutschland directly at Tel.: 0049-6172-408-435, E-Mail: <a href='mailto:{email}'>{email}</a>, as these are subject to a separate settlement.",
  yourEmail: "Your email address",
  addressEndCustomer: "Customer address",
  tireSizeExample: "Tire size (e.g. 215/60/16)",
  profileDesignation:
    "Profile designation inc. specification (e.g.: RE050A, R168 Eco, ...)",
  speedLoadIndex: "Speed/load index",
  restDay: "Rest day",
  breakTimes: "Break times",
  claimFrom: {
    pdf: {
      number: "Form number",
      tireSizeExample: "Tire size",
      dot: "DOT",
      vehicleModelType: "Vehicle model/type",
      enginePower: "Engine power (kW)",
      speedLoadIndex: "Speed index",
      profile: "Profile",
      damage: "Damage",
      replacementStamp: "Replacement mark",
      personalInjury: "Personal injury",
      tiresReplaced: "Tires replaced",
      agb: "Terms and conditions",
      clerkName: "Name of the clerk",
      complaintReason: "Complaint reason",
      complaintReasonText: "Complaint reason text",
      vehicleTyres: "Vehicle/tires",
    },
  },
  fuelCalculator: {
    oldLabel: "OLD FUEL LABEL",
    selectOldLabel: "Select label value",
    tyreLife: "Total mileage (of the tire set in KM)",
    tyreLifeLabel: "Enter total mileage, e.g. 40,000",
    fuelPrice: "Fuel price (per liter in EUR)",
    fuelPriceLabel: "Enter fuel price, e.g. 1.82",
    newLabel: "NEW FUEL LABEL",
    selectNewLabel: "Select label value",
    fuelConsumption: "Fuel consumption (of the vehicle per 100 km in liters)",
    fuelConsumptionLabel: "Enter fuel consumption, e.g. 7.8",
    table: {
      euroSave: "Savings in total mileage",
      fuelSavePercent: "Change in fuel consumption",
      newConsumption: "New fuel consumption per 100 km",
      fuelSaveLiter: "Fuel consumption decreases by 100 km",
      fuelSaveTotalLiter: "Fuel consumption decreases in the total mileage by",
    },
    results: "Results and savings potential",
    please: "Please note the notes below the results",
    calcHeader: "Enter the key data for tires and vehicle here:",
    mainDesc:
      "With the <b>Fuel Saver Calculator</b> you can easily and directly calculate the savings that a better rolling resistance class in new tires can enable compared to a worse class. Simply enter the values in the form for this.<br/><br/><b>The result relates to the total mileage and offers you an additional strong argument in the sales conversation - recommend the premium tires from Bridgestone with optimized rolling resistance!",
    description:
      "Tires with low rolling resistance that are properly inflated (according to the manufacturer's specifications) can save up to 10% in fuel. This leads to financial savings in operating costs or allows the driver, for example in electric vehicles, to travel a longer distance before refuelling or charging. The rolling resistance class ranges from A (most efficient) to E (least efficient). The higher the energy class, the lower the rolling resistance.",
    noticeText:
      "Based on the data from the European Commission, a maximum fuel saving across all label classes (Label A versus Label E) of 10% was assumed. This is a maximum value, which in particular requires that the tires be driven with the optimal air pressures specified by the vehicle or tire manufacturer (More information on this on the European Commission website: <a href='https://commission.europa.eu/energy-climate-change-environment/standards-tools-and-labels/products-labelling-rules-and-requirements/energy-label-and-ecodesign/energy-efficient-products/tyres_en'>https://commission.europa.eu/energy-climate-change-environment/standards-tools-and-labels/products-labelling-rules-and-requirements/energy-label-and-ecodesign/energy-efficient-products/tyres_en</a>) . Based on maximum fuel savings, assuming a linear reduction, there is a difference of approximately 2.5% per change to the next better label class. This percentage is deducted from the stated initial value of gasoline consumption by the calculation logic. Example: The consumption value given is 7.0 l per 100 km. The fuel savings should be calculated when switching from label C to label A. Based on the logic above, this results in 2.5% * 2 = 5%. Taking into account the specified consumption value, the following new consumption value results: 7.0 l * (100% - 5%) = 6.65 l and thus a saving of 0.35 l / 100 km.<br/><br/> Bridgestone expressly points out that the percentage change mentioned above is a theoretical value that reflects the upper range of possible fuel savings due to the rolling resistance of the tire. It therefore only serves as an approximation and will not always be achievable in practice, since the fuel consumption of a vehicle (and correspondingly its savings) depends on many other factors in addition to the pure rolling resistance of the tire (e.g. driving style, speed, tire air pressure , tire and ambient temperature, air resistance of the vehicle, vehicle load, road conditions as well as chassis and vehicle settings), which also influence each other. The results of the calculations carried out therefore only represent a non-binding, approximate estimate, for the correctness and precision of which Bridgestone assumes no liability.",
  },
  legalNotice: "Legal Notice",
  addCsNumber: {
    body: "Are you sure you want to save this customer number? The action blocks edit data until the administrator approves it.",
  },
  priceDescription: "Download current price lists for your use.",
  pricatDescription:
    "Here you can get Pricat files for your merchandise management.",
  pricat: {
    title: "Pricat",
    description:
      "Download CSV and TEXT data sets for your merchandise management and IT systems etc. here.",
  },
  fillProfile: "Fill out the profile to be able to download the certificate,",
  certificate: {
    header: "CERTIFICATE",
    atCourse: "has successfully participated in the",
    takePart: "course.",
    contains: "COMPONENTS OF THE COURSE",
  },
  afterTraining: {
    congratulations: "Congratulations",
    allAnswer: "You have answered all questions correctly",
    points: "You will receive {points} on your account immediately!",
    clickToProfile: "click on the link",
  },
  kickback: {
    title: "Kickback fee",
    word: "Kickback",
    description:
      "Kickback fees are credited to participating companies based on the sales figures submitted.",
  },
  externalLinks: {
    tyreBuy: "Order tires",
  },
  loginPageSteps: {
    welcome:
      "Welcome to BRIDGESTONE PLUS – the value-added portal from Bridgestone.",
    step1: {
      title: "New here?",
      description:
        "Are you new to the BRIDGESTONE <span class='text-danger'>PLUS</span> portal?<br /><br />Then register now!",
      actionBtn: "REGISTER NOW",
    },
    step2: {
      title: "TYRE<span class='text-danger'>CLUB</span> dealer",
      description:
        "Do you already have access data for the former Bridgestone TYRE<span class='text-danger'>CLUB</span>?<br /><br />Then set your new password here for the email address you used for the TYRE<span class='text-danger'>CLUB</span>.",
      actionBtn: "SET NEW PASSWORD",
    },
    step3: {
      title: "Welcome to BRIDGESTONE <span class='text-danger'>PLUS</span>",
      description:
        "Log in with your email address and password.<br /><br /><b>Are you a Bridgestone TYRE<span class='text-danger'>CLUB</span> participant?</b><br /><br />Then first set your new password for the email address you used for the TYRE<span class='text-danger'>CLUB</span> using the <b>Forgot password</b> function.<br /><br />After that, you will be logged in automatically.",
      actionBtn: "LOG IN",
    },
    info: 'Do you need help? Please contact us: <a href="mailto:{email}">{email}</a>',
  },
  marketingModal: {
    title: "General Terms and Conditions & Conditions of Participation",
    description:
      "After accepting the 'commitment letter' you will receive a copy by e-mail",
    content:
      "General Terms and Conditions of Bridgestone Europe NV/SA, Netherlands Branch, with registered office in Nieuwe Weideweg1 NL- 6121 PD Born Netherlands - K.v.K. 66469767 (hereinafter referred as 'Bridgestone').",
    point1Title: "Participation",
    point1Desc:
      "The General terms and conditions does not imply any commitment of the Participant to reach a market share set by Bridgestone, nor does it oblige the Participant to sell exclusively the Bridgestone’s tires. <br/>It is understood that the Participant remain free to determine their own resale prices for tires without any restrictions, even in the presence of any recommendations, which shall however be understood as non-binding. <br/>The requirements for participation in BS PLUS that are binding for the participating company with which the agreement was concluded (hereinafter referred as 'Participant'). The Participant acknowledges that admission to participation in BS PLUS is at the discretion of Bridgestone, and no claims against Bridgestone for admission are valid. The transfer or assignment of Participant accounts is expressly prohibited unless otherwise specified by Bridgestone. Pledging the Participant account is not allowed. <br/>Participants are responsible for promptly updating their personal data online. Failure to comply with this obligation may result in additional costs, delays, increased risk of damage or loss of prizes, and other associated damages.",
    point2Title: "Kickback fees and crediting of marketing points",
    point2Desc:
      "Entry level for pay-out is that the Participant buys a minimum volume of sixty (60) Bridgestone-branded car, light truck, 4x4 summer, winter and all-season tyres at the selected distributors from 1st  April 2024 till 31st December 2024. If the minimum annual volume is not reached, no kickback fees will be credited to the Participant. From 2025, the entry level for pay-out will be one hundred twenty (120) Bridgestone-branded car, light truck, 4x4 summer, winter and all-season tyres at the selected distributors from 1 January till 31 December. <br/>Points-relevant and accounting periods for the calculation of points as of 2025: January - December of each year. <br/>The kick-back fees and marketing points does not apply to 2A goods, demo tires, non-active/inactive pricelist EAN’s... Unused points from the previous expire on March of the next year. For example unused points from 2024 expire on March 01,2025. <br/>Points will be credited to the Participant exclusively at the initiation of Bridgestone and in strict accordance with the conditions set out in the Conditions Tab in Bridgestone plus platform. The number of points granted per type of tyres are accessible in the BS platform. https://plus.bridgestone.nl",
    point3Title: "Rewards",
    point31Title: "Marketing Points",
    point31Desc:
      "The Participant has nominated an employee or vicarious agent to retrieve the rewards on its behalf. This person has access to the points account of the Participant. <br/>Participants have the option to redeem the credited points for offered rewards in kind and/or services. Payment of the equivalent cash value of the accumulated points is not permitted, unless expressly stated in the rewards system. No interest accrues on the Participant's account. Points can be redeemed if the points account displays the necessary balance for the specific reward. Participants do not have a guaranteed entitlement to any particular reward, and redemption is subject to availability while stocks last. <br/>The Participant has the option to redeem the credited points for the offered rewards in kind and/or services. The payment of the equivalent cash value of the points collected points is not permitted, unless expressly stated in the rewards system. No interest will be paid on the Participant's account. The points collected can be redeemed if the points account displays the necessary balance for the specific reward. Participants do not have a guaranteed entitlement to any particular reward, and redemption is subject to availability while stocks last. <br/>Bridgestone retains the right to rectify any evident mislabeling of rewards. Redeemed points are non-transferable and cannot be exchanged for additional points or different rewards. Once the order has been placed, the Participant will promptly receive a confirmation of receipt.  Bridgestone will then promptly verify all relevant data and assess the availability of the reward. Unless explicitly   stated otherwise, all performance, dimension of the rewards remain as described. <br/>Redeemed points cannot be exchanged for points or rewards. Once the order has been placed, the participant will promptly receive a confirmation of receipt. Bridgestone will then promptly check all relevant data and the availability of the reward. Unless explicitly stated otherwise, all performance, dimension, weight, and size specifications are approximate values and are provided for descriptive purposes only; they do not constitute guaranteed properties. Delivery times will be communicated separately to the Participant after the order has been placed. In the event that the ordered item is unavailable or cannot be delivered, Bridgestone retains the right to send the Participant a comparable, similar item or to cancel the order. <br/>The marketing points must be used by the Participant before March 31st of the following year, or they will be forfeited.",
    point32Title: "Kickback fee",
    point32Desc:
      "The Participant will receive kickback fees upon the achievement of the commitments made, either directly from Bridgestone, or from a selected service provider. <br/>The kickback fee accrues when the Conditions of Participation are accepted by the Participant through tire orders facilitated by distributors appointed by Bridgestone. Bridgestone or a selected service provider disburses the kickback fees to the Participant once annually, subsequent to a verification of the accuracy of the collected data and subject to the fulfillment of the aforementioned commitments. This disbursement transpires within the first quarter of the subsequent year. For example: the kickback fee for the year 2024 is disbursed in the first quarter of 2025. <br/>This process is executed automatically subsequent to a comprehensive review of the Participant's tire orders and associated data. The Participant receives the kickback fees directly from Bridgestone or from a selected service provider. Concurrently, the Participant will be provided with a document suitable for inclusion in its financial records.",
    point4Title: "SCORE / PASSWORD",
    point4Desc:
      "The points are registered under the Participant's number. Any objections to the accuracy or completeness of the points score must be made in writing within one month of becoming awareof them. Failure to raise an objection in good time shall be deemed to constitute approval of the score. Even after the deadline has expired, a correction of the reported score may be requested if the Participant can unequivocally  demonstrate the inaccuracy and/or incompleteness. The Participant is responsible for ensuring that that its password remains confidential, and in the event of suspicion that another person has obtained knowledge of the password or any other misuse, the Participant must promptly change their password or promptly notify Bridgestone.",
    point5Title: "DEFECTS/DEFICIENCIES",
    point5Desc:
      "Defects in the delivered items must be reported immediately in writing. Otherwise, the statutory provisions shall apply.",
    point6Title: "TERMINATION",
    point6Desc:
      "Participation in BS PLUS is voluntary, and participants may choose to terminate their involvement at any time by notifying Bridgestone. It is important to note that the termination of participation does not impact the redemption of accumulated points. Bridgestone retains the right to exclude a participant from the program for justifiable reasons. ",
    point7Title: "LIABILITY",
    point7Desc:
      "The Participant assumes at its own risk all obligations in connection with its business organization relating, by way of example, to employment and self-employment relations, including insurance obligations, the correct fiscal and administrative management of the company, and the observance of current environmental, safety, and accident prevention regulations. <br/>Except in the case of willful misconduct or gross negligence, Bridgestone shall not be liable for any damage caused by the Participant in the performance of the activities referred to in the Conditions. ",
    point8Title: "MODIFICATION OF THE Conditions of Participation AND ORDERING",
    point8Desc:
      "Bridgestone reserves the right to discontinue the rewards system subject to a notice period of 3 months, in the event of an important reason also without observing such a notice period, while reasonably safeguarding the interests of the Participant. Bridgestone also reserve the right to amend or supplement the terms and conditions insofar as this is necessary in the interests of simpler and more secure processing and in particular to prevent abuse.The Participant will be notified of any changes in advance. An amendment and/or supplement shall be deemed to have been approved if it is not terminated within one month of becoming known or if the Participant takes part in the rewards program again after this period has expired. ",
    point9Title: "CONFIDENTIALITY",
    point9Desc:
      "The Participant undertakes, for himself and for his employees and collaborators, not to divulge to third parties and not to use, information of a confidential nature, such as technical information, advertising or financial data, commercial information, know-how, prices, costs, administrative information, operational present and future projects, Bridgestone strategies, or any other information which at the time of disclosure is not yet in the public domain. This clause must also be understood as binding for the subsequent five years from the termination of the participation. ",
    point10Title: "DATA PROTECTION",
    point10Desc:
      "Bridgestone, its selected service provider and the Participant undertake to comply with any obligations under Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the 'protection of individuals with regard to the processing of personal data and on the free movement of such data' (hereinafter 'GDPR') a, as well as the relevant national regulations and the measures of the Data Protection Authority. In order to participate to BS PLUS, various personal data must be collected, stored and used. This data is required in order to open a personal points account for the Participant and to be able to send them information relating to the rewards program. The mandatory data required for participation includes company name, surname, first name, position in the company, full postal address, telephone number, BTW number, bank account number and e-mail address. For the purpose of processing and implementing BS PLUS, the Participant's data will be stored and used by TAKTZEIT, Bridgestone or a service company commissioned by TAKTZEIT. Bridgestone and TAKTZEIT also undertake to comply with the statutory data protection regulations. Data will only be passed on to third parties if these third parties serve as vicarious agents, e.g. for the processing of a rewards order. By participating in the rewards program, the Participant declares his/her consent by confirming this, which can be revoked in writing at any time. With the declaration of consent, the Participant receives the corresponding newsletter. It is possible to unsubscribe from the newsletter at any time via the menu item 'Contact > Unsubscribe newsletter'",
    point11Title: "Intellectual property",
    point11Desc:
      "The Participant acknowledges and accepts that all intellectual property rights (hereinafter referred to as 'IPR'), both present and future, relating to, subsisting in or in any way connected with the BS Plus are the property of the Bridgestone group. The Participant is permitted to use IPRs solely in connection with its business of selling tyres and providing services. Internal and external point of sale recognition projects must be approved by Bridgestone. It is understood that if the Participant intends to use the IPR in any form of communication to the public, the promotional and advertising material prepared for the purpose must be submitted to Bridgestone for prior approval. Bridgestone will have the right to check at any time, by means of an on-site inspection at the premises of the Participant, that the rules for the use of IPRs are respected. The Participant may not in any way assign the use of the IPRs and/or otherwise dispose of them to third parties. ",
    point12Title: "FINAL PROVISIONS ",
    point121Desc:
      "Amendments or additions to these terms and conditions must be made in writing. This also applies to the waiver of this written form requirement.",
    point122Desc:
      "The Dutch Law shall apply to the exclusion of the UN Convention on Contracts for the International Sale of Goods. For any dispute connected with or arising out of the Commitment Letter, the Parties elect the exclusive jurisdiction of the Rotterdam Court, The Netherlands.  ",
    point123Desc:
      "Should individual provisions of these terms and conditions be ineffective or contradict the statutory regulations, this shall not affect the remainder of the contract.The invalid provision shall be replaced by the contracting parties by mutual agreement by a provision which comes closest to the economic sense and purpose of the invalid provision in a legally effective manner. ",
    point1234Desc:
      "The aforementioned provision applies correspondingly in the case of any gaps or omissions. Verbal agreements are deemed invalid, and only the Conditions of Participation outlined in the General Terms and Conditions (GTCs) shall be considered binding. ",
    point13Title: "RETURN POLICY ",
    point13Desc:
      "The Participant has a 14-day right of return. <br/>In this case, he/she must write to: Bridgestone Europe NV/SA Netherlands Branch,  with registered office in Nieuwe Weideweg1 NL- 6121 PD Born Netherlands. Bridgestone will provide the participant with the necessary instructions for the return process. The return period commences upon the Participant's receipt of the goods. In the event of a return from a delivered product, the purchaser is responsible for covering the return costs if the delivered goods match the ordered items. The points utilized by the Participant for the redeemed reward will be reinstated in the points account. The right of return is not applicable to items that have been customized to specifications or are clearly tailored to personal requirements.",
  },
  commitmentLetter: {
    title: "Conditions of Participation",
    short_description: "Enter your contact and company details here.",
  },
  kickbackInfo: {
    title: "Explanation of the Kickback fee and points",
    short_description:
      "Here you can see how to earn Kickback fees and marketing points.",
    description:
      "With <b>BRIDGESTONE PLUS</b> you collect points and a Kickback fee for all Bridgestone tires that you order from dealers appointed by Bridgestone. Below you can see how you collect points and Kickback fees. <br /><br />><b>Rules:</b><ul><li>For every Bridgestone tire you will receive marketing points that you can redeem in the shop. The number of points you will receive per tire depends on the tire's inch size.</li><li>The Kickback compensation accrues over the course of the year through tire orders at dealers appointed by Bridgestone. Bridgestone will pay the Kickback compensation to the participant once a year after verifying the accuracy of the collected data and subject to the condition that you have purchased at least 120 tires per year. This payment will be made in the first quarter of the following year. Example: The payment of the Kickback compensation for the year 2024 will be made in the first quarter of 2025. This process will be done automatically after verification of the tire orders and your data. You will receive the Kickback compensation directly from Bridgestone or through its external partner. You will also receive a document that is suitable for inclusion in your financial administration.</li></ul>",
    tableFooter:
      "No Kick-Back fee for the other product groups: TBR, MC, OTR, AG",
    withdraw: "For the payout of the kickback fee",
  },
  pause: "PAUSE",
  myProfile: "My profile",
  tyreAmount: "Tire quantity",
  rewardsOverview: {
    titlePoints: "Marketing points (1 point = 0.25 EUR)",
    titleKickback: "Kickback fee bonus in EUR",
    footerPoints:
      "No marketing points for other product groups: TBR, MC, OTR, AG",
    kickbackPoints:
      "No kickback fee for other product groups: TBR, MC, OTR, AG",
    groupLevel: "Group level",
  },
  group: "Group",
  major: "Major",
  strategicPartners: {
    cardTitle: "Contact our strategic partners",
    title: "Contact the sales partner",
    description:
      "We are ready for you! Below you will find the details of your wholesaler contacts.",
    short_desc:
      "Do you have questions about your tire orders from affiliated distributors? Click below for their contact details",
  },
  onlineVisibility: {
    box: { title: "Online visibility" },
    title: "Online visibility",
    description:
      "Increase and control your digital visibility at POS level with UBERALL",
    category_title: "Everywhere subscription - term 1 year",
    category_description:
      "Use your reward points now to take your digital location marketing to the next level. Using the ubiquitous platform, Bridgestone helps retail partners optimize their online presence to drive more traffic. And on over 100 platforms such as Google, Facebook, Bing or Trustpilot.",
    content: "Take advantage of the benefits now from anywhere:",
    point1: "Optimizing online visibility",
    point2: "Convenient management and control of POS locations",
    point3: "Track local visibility, reviews and social media content",
    footer:
      "To get detailed information and get a first impression of everywhere, watch the following video.",
    period: "Term: 1 year for <span class='success-green'>480 points</span>",
    form: {
      title: "How to use anywhere for your business:",
      point1: "Take out an annual subscription for 480 points",
      point2: "After an internal check, you will receive a confirmation",
      point3: "no automatic extension",
      pointDiscount: "Points in a {price} EUR of for the following",
      howMuch: "How many points do you want to stake?",
    },
  },
  media: {
    title: "Media packages",
    short_description:
      "Here you will find data for social media, in-store TV and more.",
    description:
      "Here you will find images, videos and digital media for free use. Use our media packages for your own social media presence, in-store TV or digital advertising.",
  },
  sortBy: {
    default: "Sort by",
    desc: "Sort by: Newest",
    asc: "Sort by: Oldest",
  },
  bridgestoneProductBrochures: {
    title: "Bridgestone products",
    description:
      "Download the latest brochures and flyers about our Bridgestone tires for cars, SUVs and vans here.",
    files: {
      desc1: "PKW, SUV - Winter",
    },
  },
  testResult: "Test results",
  productOverview: "Product overview",
  summary: "Summary",
  information: "Information",
  brochure: "Brochure",
  makeChoice: "Make your choice here",
  winterIn: "Winter in",
  summerIn: "Summer in",
  allSeasonIn: "All season in",
  at: "at",
  tyreBox: {
    title: "Tyres",
    totalAmount: "Total tyres",
    target: "Your target",
    entry: "Your entry",
  },
  firstStop: {
    description:
      "On this page you will find the warranty conditions and the declaration forms for the First Stop tire warranty. NB; Due to the procedure adjustment in 2024, there are 2 different procedures based on the purchase date of the tire.",
    section1: {
      title: "Real Garant procedure (tires purchased until February 29, 2024)",
      description:
        "The Real Garant procedure applies to tires purchased by February 29, 2024. Below you can download the conditions and the declaration form",
    },
    section2: {
      title: "First stop process (tires purchased from March 1, 2024)",
      description:
        "If new, only the tires will be refunded. The consumer bears the costs of installation and the environmental impact of the newly installed tire. First Stop will refund the purchase price of the tire. You can freely determine the amount of the assembly rate. Please specify this. Always shown separately on the new invoice.",
      footer:
        "The rest of the claim handling procedure hardly changes. Below you can download the conditions, the claim form and the procedure.",
    },
  },
  languageSelect: {
    title:
      "Welcome to <b>BRIDGESTONE PLUS</b> - the premium portal from Bridgestone.",
    label: "Language Selection",
    description:
      "Please select your language/ Choose your language/ Select your language",
  },
  current_tyres_amount: "Tyre amount",
  current_points: "Score",
  current_kickbacks: "Kick-back",
  phoneShortCut: "Phone.",
  mediaCategories: {
    products: "Products",
    brand_and_solutions: "Brand & Solutions",
    season_and_promotions: "Season & Promotions",
    format: "Format",
    cars_and_vans: "Cars & Vans",
    truck_and_buses: "Truck & Bus",
    motorcycle: "motorcycle",
    agriculture: "agriculture",
    construction_machinery: "Construction Machinery",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    summer: "summer",
    winter: "winter",
    all_season: "All Season",
    promotions: "promotions",
    video_in_store: "Video (Instore)",
    video_online: "Video (Online)",
    banner_website: "Banner (website)",
    banner_social_media: "Banner (Social Media)",
    logos: "Logos",
    b_drive: "B-drive",
    media_library: "Media library",
    media_packages: "Media packages",
  },
  placeholders: {
    searchMedia: "Enter a search term",
  },
  searchResults: "Search results",
  setFilters: "Bitte setzen Sie Ihre Auswahlfilter",
  kickbackExchange: {
    title: "Kickback exchange",
    description:
      "Please enter the amount of fee's you would like to exchange<sup>*</sub>:",
    disclaimer: "Entry level: {tyres} tires needed",
    afterExchange: "Your statement of account after exchange:",
  },
  productSearchBox: {
    from: "points from",
    to: "points to",
  },
  validators: {
    min_money: "Field must be greater then {min} €",
    max_money: "Field must be lower then {max} €",
  },
  subMediaPage: {
    description:
      "Welcome to the media area for Bridgestone and Firestone products. Here you will find current product images, logos as well as numerous banners, videos and digital templates for use on your website or on social media, for example.",
  },
  brochure_prices: {
    description:
      "Download current brochures, flyers and price lists for our Bridgestone and Firestone tires for cars, SUVs and vans here.",
  },
  brochureCategories: {
    products: "Products",
    brand_and_solutions: "Brand & Solutions",
    season_and_promotions: "Season & Promotions",
    format: "Format",
    cars_and_vans: "Cars & Vans",
    summer: "Summer",
    winter: "Winter",
    promotions: "Promotions",
    all_season: "All Season",
    truck_and_buses: "Trucks & Buses",
    motorcycle: "Motorcycle",
    agriculture: "Agriculture",
    construction_machinery: "Construction Machinery",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materials",
    brochures: "Brochures",
    price_list: "Price List",
    materials: "Materials",
  },
  favoriteProducts: {
    description: "Here you will find the products you have saved.",
  },
  multiplicator: {
    title: "Bonus multiplicator",
    bandBonusTitle: "Bonus per tyre at multiplicator",
    amountLabel: "Min. number of tyres (*)",
    label: "Bonus multiplicator",
    desc: "Number of Bridgestone and Firestone tyres. There is no bonus in euros on Firestone tyres.",
    goals: {
      loyal: "Loyal",
      bronze: "Bronze",
      silver: "Silver",
      gold: "Gold",
      platinum: "Platinum",
    },
    andMore: "and more",
    chooseTarget: "Select",
    selectTarget: "Select your annual target for {year} here:",
    multiplication: "Bonus is multiplied by <b>{factor}</b>",
    minTyres: "<b>Minimum:</b> {tyre} tyres",
  },
  bsPlus: {
    buttons: {
      appButtons: {
        pending: "Pending",
        open: "Open",
        requestAccess: "Request access",
      },
    },
    homepage: {
      my: "Apps",
      titleColorRev: "false",
      welcomeMessage:
        "Welcome to BRIDGESTONE <span class='text-danger'>PLUS</span>, %{first_name} %{last_name}",
      showProfile: "Show Profile",
      newMessages: "New messages in your inbox",
      directRoute: "Your direct route to all Bridgestone web applications.",
      myAppsDescription:
        "all Bridgestone web applications for which you are already a member",
      allAppsDescription:
        "All Apps - All the Bridgestone web applications that may be of interest to you.",
      home: "Home",
      search: "Search",
      sortBy: "Sort by",
      myApps: "My Apps",
      allApps: "All Apps",
      inbox: "Inbox",
      profile: "Profile",
      seeMore: "See more",
      showMessages: "Show messages",
    },
    myProfile: {
      welcomeMessage:
        "Welcome to your personal area. Here, you can update or adjust your master data and view your inbox.",
      masterData: "Master Data",
      completeDetails:
        "Complete your personal and company details for a successful registration.",
      goToMasterData: "Go to Master Data",
      goToInbox: "Go to inbox",
    },
    masterData: {
      welcomeMessage:
        "Welcome to your personal area. Here you can update or adjust your master data.",
      personalDetails: "Personal details",
      companyDetails: "Company details",
      emailAddress: "Email address",
      title: "Title",
      surname: "Surname",
      firstName: "First name",
      jobPosition: "Job position",
      streetAndHouseNumber: "Street & house number",
      postalCode: "Postal code",
      city: "City",
      country: "Country",
      legalStructure: "Legal structure",
      customerNumber: "Customer number",
      importantPleaseRead: "Important please read",
      customerNumberInfo:
        "To properly assign your tire orders to wholesalers and/or Bridgestone, it is essential that you provide your respective customer numbers.",
      multipleCustomerNumbers:
        "If you have multiple customer numbers with a wholesaler and/or Bridgestone, for example, for your main business and your branches, please provide the customer number for the main business first.",
      salesAssignment:
        "The sales associated with the additional customer numbers will then be assigned to your main business.",
      supplier: "Supplier",
      addAnotherCustomerNumber: "Add another Bridgestone customer number",
      save: "Save",
      delete: "Delete",
    },
    inbox: {
      welcomeMessage: "Here you can find important notifications and news.",
      sender: "Sender",
      subject: "Subject",
      date: "Date",
      formConsulting: "Form Consulting - Thank you for processing the form",
      back: "Back",
    },
    legalAndContact: {
      cookieSettings: "Cookie-settings",
      dataPolicy: "Data policy",
      termsOfUse: "Terms of use",
      helpAndContact: "Help and contact",
    },
    logInSignUp: {
      logIn: "Log in",
      signUp: "Sign up",
      logInMessage: "Log in with your email address and password.",
      signUpMessage: "If you are a new user, please register.",
    },
    onboarding: {
      tradingPartner: "I am a trading partner that is",
      termsAndConditions: "Terms and Conditions",
      accept: "Accept",
      decline: "Decline",
      scrollToAccept:
        "Please scroll down for accepting our conditions to continue",
      welcomeMessage: "Welcome to Bridgestone Plus",
      dataModal:
        "In order to be able to adapt this offer to your needs, we ask you to kindly identify yourself and indicate your interests in terms of products or sectors of activity.",
      tailorOffer:
        "In order to be able to tailor this offer to your interests, we would ask you to briefly state your product interests or business areas.",
      selectAreas: "Please select* from the following areas",
      multipleAnswers: "(multiple answers possible)",
      personalPreferences: "Personal Preferences",
      carTyres: "Car tyres, SUV, utility",
      motorcyclesTyres: "Motorcycles tyres",
      truckBusTyres: "Truck and bus tyres",
      agricultureTyres: "Tyres for agricultural vehicles",
      otrTyres: "OTR tyres",
      save: "Save",
      businessRelationship:
        "What is your business relationship with Bridgestone?",
      selectRelationship: "Please select* from the following areas",
      tradingPartnerDirect: "... directly ordering from Bridgestone",
      tradingPartnerIndirect: "... indirectly ordering (via wholesale e.g.)",
      tradingPartnerBoth: "... both directly and indirectly ordering",
      fleetResponsibleDirect:
        "I am a fleet responsible that is... directly ordering from Bridgestone",
      fleetResponsibleIndirect:
        "... indirectly ordering (via trade or wholesale)",
      fleetResponsibleBoth: "... directly and indirectly ordering",
      noBusinessRelationship:
        "I have no business relationship with Bridgestone (neither directly nor indirectly)",
      yourCustomerNumber: "Your Bridgestone customer number*: ",
      enterCustomerNumber: "Enter your customer number",
      waitPersonalisedView:
        "Please wait a moment, your personalised view of BRIDGESTONE PLUS will be generated.",
      personalised: "Personalised",
      plusInfo:
        "Here you will find information about your Plus account and your Plus mailbox.",
      continue: "Continue",
      skip: "Skip",
      oneOfTwo: "1 of 2",
      openApps:
        "You can directly open the apps you are already registered for. You can also request access to other apps that may be relevant to you.",
      requiredFields:
        "Fill in the required fields: Title, First name, Last name",
      stage: "Part",
    },
  },
};
